"use strict";

exports.__esModule = true;
exports.totalXAxisPartitions = exports.tickYFormat = exports.normalizeSeries = void 0;
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../../../../Utils");
var _GroupedBarChart = require("./GroupedBarChart");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getXValue = function getXValue(input) {
  return input.key;
};
var getYValue = function getYValue(input) {
  return input.value;
};
var getYValuePercent = function getYValuePercent(input) {
  return input.value ? input.value * 100 : 0;
};
var defaultRender = function defaultRender(props) {
  return /*#__PURE__*/_react["default"].createElement(_GroupedBarChart.GroupedBarChart, props);
};
var normalizeSeries = exports.normalizeSeries = function normalizeSeries(series) {
  var unit = series.unit,
    color = series.color;
  return Object.assign({
    getXValue: getXValue,
    getYValue: unit === "FRACTIONAL_PERCENT" ? getYValuePercent : getYValue,
    color: color,
    render: defaultRender
  }, series);
};
var tickYFormat = exports.tickYFormat = function tickYFormat(units, value) {
  if (units === "MILLISECOND") {
    if (value === 0) {
      return "0";
    }
    return (0, _Utils.formatDuration)(value);
  }
  return value;
};
var totalXAxisPartitions = exports.totalXAxisPartitions = function totalXAxisPartitions(series) {
  var collected = new Set();
  for (var _iterator = _createForOfIteratorHelperLoose(series), _step; !(_step = _iterator()).done;) {
    var data = _step.value.data;
    for (var _iterator2 = _createForOfIteratorHelperLoose(data), _step2; !(_step2 = _iterator2()).done;) {
      var key = _step2.value.key;
      collected.add(key);
    }
  }
  return Array.from(collected).length;
};